import { BusinessException } from "../model/BusinessException";


const env_dev = {
    appPath: function (name?: w2p.environments.AppName): string {
        let path = window?.location?.href || "/";
        // let rootPath = path.match(/(^[htps]*):\/\/([\w.\d]+(:[\d]+)?(\/stage)?)/gi);
        let rootPath = window?.location?.origin;
        if (rootPath != undefined && rootPath != null) {
            if (name) {
                return rootPath + "/" + this.apps[name];
            } else {
                return rootPath;
            }
        } else if (path == "/" || path == "about:blank") {
            return path;
        }

        throw new BusinessException("A00001");
    }

}

export { env_dev }